module.exports = __webpack_public_path__ + "static/media/Team 30 - Innovation Geeks.fe455a05.png";